import { useState } from 'react';
import { useTranslation } from "next-i18next";
import PropTypes from "prop-types";
import Swatch from "../Swatch";
import { sizeOptionIsWaistLength } from './lib/size-options-is-waist-length';
import { WaistLengthSelector } from './WaistAndLengthSelector';
import styles from "./styles/selection.module.css";

function ColourSelector({ navigation, heading, handleNavigationChange, product}){
  return (
    <Swatch
      data={navigation}
      heading={heading}
      name={"colour"}
      handle={"colour"}
      updateVariant={handleNavigationChange}
      previewOnHover={handleNavigationChange}
      product={product}
    />
  )
}

function SizeSelector({_key, heading, options, handleOptionChange, openSizeGuide, product }) {
  return (
    <>
      <Swatch
        key={_key.toLowerCase()}
        name={_key.toLowerCase()}
        handle={_key.toLowerCase()}
        data={options}
        heading={heading}
        updateVariant={handleOptionChange}
        openSizeGuide={openSizeGuide}
        product={product}
      />
    </>
  );
}

function shouldRemoveOpenBox(options, openBox) {
    if (!openBox) {
      return options.filter(option => !option.isOpenBox);
    }
    return options.filter(option => option.isOpenBox);
}

export function Selection({
  navigation,
  options,
  product,
  handleNavigationChange,
  handleOptionChange,
  openSizeGuide,
}) {
  const { t } = useTranslation("productpage");
  const COLOUR = t("colour");
  const SIZE = t("size");
  return (
    <div className={styles.container}>
      {navigation && navigation.length > 1 && (
        <ColourSelector
          heading={COLOUR}
          navigation={navigation}
          handleNavigationChange={handleNavigationChange}
          product={product}
        />
      )}

      {Array.from(options.keys()).map((key) => {
        if (options.get(key).length > 1 && key) {
          if (sizeOptionIsWaistLength(options, product, key)) {
            return (
              <WaistLengthSelector 
                key={key}
                heading={SIZE}
                options={Array.from(options.get(key).values())}
                handleOptionChange={handleOptionChange}
                openSizeGuide={openSizeGuide}
                product={product}
              />
            )
          }
          else if (key === 'Size') {
            const notOpenBoxOptions = shouldRemoveOpenBox(Array.from(options.get(key).values()), false)
            const openBoxOptions = shouldRemoveOpenBox(Array.from(options.get(key).values()), true)
            return (
              <>
              <SizeSelector
                _key={key}
                heading={SIZE}
                options={notOpenBoxOptions}
                handleOptionChange={handleOptionChange}
                openSizeGuide={openSizeGuide}
                product={product}
              />
              {openBoxOptions.length > 0 && (
                <SizeSelector
                  _key={`${key}-openbox`}
                  heading={'Open Box (Final Sale)'}
                  options={openBoxOptions}
                  handleOptionChange={handleOptionChange}
                  openSizeGuide={openSizeGuide}
                  product={product}
                />
              )}
              </>
            )
            } 
            else if (key !== 'Size' && key !== 'Colour' &&  key !== 'Color' && !sizeOptionIsWaistLength(options, product, key)){
              console.log('KEYSSSS', key)
              return (
                <>
                  <SizeSelector
                  _key={key}
                  heading={'Gift Card'}
                  options={Array.from(options.get(key).values())}
                  handleOptionChange={handleOptionChange}
                  openSizeGuide={openSizeGuide}
                  product={product}
                />
                </>
              )
            }
        }
      })}
    </div>
  );
}

Selection.propTypes = {
  navigation: PropTypes.array,
  options: PropTypes.object,
  handleNavigationChange: PropTypes.func,
  handleOptionChange: PropTypes.func,
};
